module.exports = __webpack_public_path__ + "public/img/logo1.b784dc29.png";